import i18n from "../../../../../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../../../../../../core/et3-enhanced-render";
import Et3Badge from "../../../../../../../core/et3-shared-components/Et3Badge";

const TesterBadge = withLiteObserverAndTheme<{
  isTester: boolean;
  style: React.CSSProperties;
}>((props) => {
  const { isTester, style } = props;

  return !isTester ? null : (
    <Et3Badge type="DEFAULT" content={i18n.get("TESTER")} style={style} />
  );
});
export default TesterBadge;
